import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import cartConfig from "emun.cart/cart.config";
// import moment from "moment";
import AutoQuery from "servicestack/auto-query/auto-query";
import modals from "webmodals/modals";

export default class OrderLogDetailController {
	constructor(options) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.bus = new ServiceBus();
		$ctrl.config = cartConfig;
		$ctrl.order = Object.assign({}, options.model, options.order);
		$ctrl.title = options.title || "Error Log";
		$ctrl.shipOn = moment();
		//$ctrl.trackingNumbers = [];
	}
	$onInit() {
		const $ctrl = this;
        $ctrl.bus.read('HostedPCI/QueryLog.json?OrderNumber=' + $ctrl.order.id).then(res=> {
            $ctrl.hostedPciLogs = res.data.results;
        });
        $ctrl.bus.read('QueryTags.json?Shard=Order&PrincipalId=' + $ctrl.order.id).then(res=> {
			$ctrl.tags = [];
			res.data.results.map(r => {
				if (/failure$/i.test(r.tagKind)) {
					r.errorDescription = JSON.parse(r.tagLabel);
					$ctrl.tags.push(r);
				}
			})
        });
	}
	clearReview(order) {
		const $ctrl = this;
		return modals.confirm("Clear review status for this order?", "Clear Review Status").result.then(function() {
		  $ctrl.bus.send("ClearReview.json", {
			OrderNumber: $ctrl.order.id
		  }).then(function(response) {
			$ctrl.$dismiss();
		  });
		});
		
	  }
	}
